
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ritual-praxis-and-instructions/components/chapter_5",
      function () {
        return require("private-next-pages/ritual-praxis-and-instructions/components/chapter_5.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ritual-praxis-and-instructions/components/chapter_5"])
      });
    }
  